export class Visitation {
  public constructor(
    public webUrl: string,
    public fileName: string,
    public id: string,
    public orderType: string,
    public partNumber: string,
    public c64Date: Date | string,
    public material1: string,
    public material2: string,
    public planningStatus: string,
    public devSegment: string,
    public mouldDefinition: string,
    public mouldType: string,
    public cavities: string,
    public mmProfile: string,
    public mqProfile: string,
    public mould1Plant: string,
    public tedStart: Date | string,
    public tedEndC45: Date | string,
    public ptyStart: Date | string,
    public ptyEndC46: Date | string,
    public ptyEvalStart: Date | string,
    public ptyEvalEndC47: Date | string
  ) {}
}
